
import * as Bluebird from "bluebird"
import BluebirdDefault from "bluebird"

declare global { export interface Promise<T> extends Bluebird<T> {} }

BluebirdDefault.config({
  // Enables all warnings except forgotten return statements.
  warnings:         false,
  // Enable long stack traces
  longStackTraces:  true,
  // Enable cancellation
  cancellation:     true,
  // Enable monitoring
  monitoring:       true,
})

export default BluebirdDefault
